import React from "react";

import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Drawer from "@material-ui/core/Drawer";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import styled from "styled-components/macro";

import { SidebarBranding } from "./SidebarBranding";

const CloseButton = styled(FontAwesomeIcon)(
  ({ theme }) => `
  color: ${theme.colors.white};
  position: absolute;
  right: ${theme.space[4]}px;
  top: ${theme.space[3]}px;
  font-size: ${theme.fontSizes.epsilon}px;
`,
);

const useStyles = makeStyles(theme => ({
  drawerOpen: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    width: "80%",
  },
  drawerClose: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: "0px",
  },
}));

interface MobileSideBarProps {
  ContentElement: React.ElementType;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onAfterCloseSidebar: () => void;
  isBrandingVisible?: boolean;
}

export const MobileSideBar = ({
  ContentElement,
  isOpen,
  setIsOpen,
  isBrandingVisible = true,
  onAfterCloseSidebar,
}: MobileSideBarProps) => {
  const styles = useStyles();

  const handleDrawerClose = () => {
    setIsOpen?.(false);
    onAfterCloseSidebar?.();
  };

  return (
    <Drawer
      variant="temporary"
      className={clsx({
        [styles.drawerOpen]: isOpen,
        [styles.drawerClose]: !isOpen,
      })}
      classes={{
        paper: clsx({
          [styles.drawerOpen]: isOpen,
          [styles.drawerClose]: !isOpen,
        }),
      }}
      open={isOpen}
    >
      <CloseButton onClick={handleDrawerClose} icon={faTimes} />

      {isBrandingVisible && <SidebarBranding isOpen={isOpen} />}
      {ContentElement && (
        <ContentElement closeSidebar={handleDrawerClose} isOpen={isOpen} />
      )}
    </Drawer>
  );
};
